import * as Yup from 'yup'

import { initialLanguagesValues } from '../../../CampaignForms/CampaignGoogleCreate/CampaignGoogleLanguagesForm/fields'
import { languagesCreateValidation } from '../../../../../features/validations/languages'

export const initialValues = {
  ...initialLanguagesValues
}

export const validationSchema = Yup.object({
  ...languagesCreateValidation
})
